module.exports = __webpack_public_path__ + "static/media/clubs-rental.88514a77.svg";